import React, {forwardRef} from 'react'

const NewEventBar = forwardRef(({...root}, ref) => {
  return <div ref={ref} className={`event-bar event-bar--new`} {...root}></div>
})

export default NewEventBar
